/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var StackHDownIcon24Solid = forwardRef('StackHDownIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8 2a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H8Z" }),
        React.createElement("path", { d: "M5 6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M2 11.75A3.75 3.75 0 0 1 5.75 8h12.5A3.75 3.75 0 0 1 22 11.75v6.5A3.75 3.75 0 0 1 18.25 22H5.75A3.75 3.75 0 0 1 2 18.25v-6.5Z" })));
});
